<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ScrollRow from "../ScrollRow.vue";
import FormatItem from "./FormatItem.vue";
import CustomItem from "../CustomItem.vue";
import StarsAnimation from "@/components/StarsAnimation.vue";

const store = useStore();

const addFormat = (format) => store.dispatch("format/addFormat", format);

const loading = computed(() => store.state.format.loading);
</script>

<template>
  <section>
    <div class="mb-6 flex flex-col lg:mb-8">
      <p class="mb-4 text-base font-bold text-primary">Format</p>
      <ScrollRow>
        <FormatItem />
        <div
          v-if="loading"
          class="bg-gray-10 flex flex-col items-center justify-center w-24 h-24 mr-4 rounded-lg cursor-pointer"
        >
          <StarsAnimation :width="96" />
        </div>
        <CustomItem
          v-else
          :itemType="'format'"
          @submit="addFormat({ format: $event, emoji: '📝' })"
        />
      </ScrollRow>
    </div>
  </section>
</template>
